import React, { useState, useEffect } from "react"

import Alert from 'react-bootstrap/Alert'
import Form from 'react-bootstrap/Form'
import FormControl from 'react-bootstrap/FormControl'
import Button from 'react-bootstrap/Button'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Spinner from 'react-bootstrap/Spinner'
import Table from 'react-bootstrap/Table'

import axios from "axios";
import $ from 'jquery';
import tabler from './nlp/tabler_adl.js';
import frm from './formAux.js'
import dash from './dashboardTools.js';
import plotly from './plotlyTools.js'

import './nlp/tabler.css';


function px(v) { return v+'px'; }
function pc(v) { if( v < 0 ) v = 0; if( v > 100 ) v = 100; return Math.round(v)+'%'; }
function val(v) { v = parseFloat(v); if( isNaN(v) ) v = 0; return v }
function ival(v) { return Math.floor(val(v)) }
function isstring( o ){ return typeof(o) == 'string';}
function isarray( o ){ return o instanceof Array;}
function isobj( o ){ return o instanceof Object;}
function isnumber( o ){ return typeof(o) == 'number' && !isNaN(o);}
function defined( o ){ return typeof(o) != 'undefined';}
function clone(o) { return JSON.parse(JSON.stringify(o)); }
function getmsec(){	return new Date().getTime(); }
function getsec(){ return Math.round(getmsec()/1000); }
function nullFunc() { return null; }
function simplify(s) { return s.replace(/[^a-z0-9]/ig,'').toLowerCase() }
function iarray( v, n )
{
	var ret = [];
	for( var i = 0 ; i < n ; i++ )
	ret.push( v instanceof Object ? clone(v) : v );
	return ret;
}

function bool( s )
{
	if( typeof(s) == 'boolean' ) return s;
	if( !defined(s) || s === null ) return false;
	if( typeof(s) == 'number' ) return s > 0;
	if( s.match(/^y/i) ) return true;
	return false;
}

function sbool( v )
{
	return ['No','Yes'][v];
}

function objCmp(a, b) {
	try {
		return JSON.stringify(a) == JSON.stringify(b);
	} catch (e) { console.error(e); return false; }
}

function mergeObj(a, b) {
	try {
		for (var k in b) a[k] = b[k];
	} catch (e) { console.error(e) }
}

function mergeCount(a, b) {
	try {
		for (var k in b) {
			if (!a[k]) a[k] = b[k];
			else a[k] += b[k];
		}
	} catch (e) { console.error(e) }
}

function addCount(o, key, v) {
	try {
		if (!v) v = 1;
		if (isobj(v)) {
			if (!o[key]) o[key] = {};
			for (var k in v)
				o[key][k] = (o[key][k] || 0) + (v[k] || 0);
		}
		else {
			o[key] = (o[key] || 0) + (v || 0);
		}
	} catch (e) { console.error(e) }
}

function sortCount(a) {
	try {
		var scount = [];
		for (var k in a) {
			scount.push([k, a[k]]);
			delete a[k];
		}
		scount.sort((a, b) => a[1] > b[1] ? -1 : 1);
		for (var i of scount) a[i[0]] = i[1];
	} catch (e) { console.error(e) }
}

var projectList = null;
var aname = null;


function Dashboard(prop) {

    var global = window.GlobalVars;
    var tasks;
	var companies = null;
	var companyNames = {};
	var selProject = '';
	var selCompany = '';

	function countLabels( a )
	{
		var labs = {};
		if( !a ) return labs;
		function add(l) { if( !labs[l] ) labs[l] = 0; labs[l]++ }
		if( a.tags ) for( var t of a.tags ) add( t.type )
		if( a.links ) for( var t of a.links ) add( t.relationship )
		if( a.boxes ) for( var t of a.boxes ) add( t.label )
		if( a.classifications )
		{
			for( var cn in a.classifications )
			{
				if( a.classificationTypes && a.classificationTypes[cn] != 'text' )
					a.classifications[cn].forEach( o => add( o ))
			}
		}

		return labs;
	}

	function getUName( r, email )
	{
		return (r[email] && r.userData[r[email]].name) || '';
	}

	function dashboard( but )
	{
		// console.log( 'dashbaord', but, projectList ); return;

		var db = $('#dashboard');
		db.html('').append($(`
				<div class="container-fluid">
				<select class="form-control dash-sel" id="selcompany"><option value="">All Companies</option></select>
				<select class="form-control dash-sel" id="selproject"><option value="">All Projects</option></select>
				</div>
		`));

		if( companies.length > 1 )
		{
			for(var c of companies) {
				$('#selcompany').append($('<option>').html(companyNames[c]).val(c))
			}
			$('#selcompany').val(selCompany).on('change', function(){
				var c = $('#selcompany').val();
				if( c == selCompany ) return;
				selCompany = c;
				if( c )
				{
					selProject = '';
					runDash( [c] )
				}
				else
				{
					selProject = '';
					runDash( companies )
				}
			})
		}
		else
		{
			$('#selcompany').hide();
		} 

		$('#selproject').on('change', function(){
			let p = $(this).val();
			if( p == selProject ) return;
			selProject = p;
			runDash( companies );
		})


		var ncharts = 0;
		var chartRow = null;
		function addChartDiv()
		{
			if( !(ncharts % 2) )
			{
				chartRow = $('<div class="row">');
				db.find('.container-fluid').append(chartRow)
			}
			var divCont = $('<div class="ccol-sm col-6 chart-'+ncharts+'">')
			var div = $('<div class="dashboard-cell">')
			divCont.append(div);
			chartRow.append(divCont);
			ncharts++;
			return div;
		}
		var labels = {};
		var annotators = {};
		var qcs = {};
		var states = {};
		var projects = {};
		var pname = {};
		var plist = {};
		console.log( 'projectList', projectList )
		for( var r of projectList )
		{
			plist[r.id] = r.name;
			if( selProject ) if( r.id != selProject ) continue;
			mergeCount( states, r.states );
			var rlab = r.labels;
			mergeCount( labels, r.labels );
			for( let e in r.annotators ) {
				let v = r.annotators[e];
				e = e.replace(/\*/g, '.');
				addCount( annotators, e, v )
			}
			for( let e in r.qcs ) {
				let v = r.qcs[e];
				e = e.replace(/\*/g, '.');
				addCount( qcs, e, v )
			} 
			projects[r.id] = {
				tasks: r.num_files,
				completed: (r.states[4]||0)+(r.states[7]||0)+(r.states[8]||0),
			}
			pname[r.id] = r.name;
		}
		if( !aname ) {
			var emails = {};
			for( var e in annotators ) emails[e] = 1;
			for( var e in qcs ) emails[e] = 1;
			emails = Object.keys(emails);
			console.log( 'EMAILS', emails );
			window.post('find_users', {match:{email:{$in:emails}}}, function(res) {
				aname = {};
				for( var u of res.data.records ) {
					aname[u.email] = u.name;
				}
				dashboard();
			})
			return;
		}


		sortCount(labels);
		for( var p in plist ) $('#selproject').append( $('<option>').val(p).html(plist[p]));
		$('#selproject').val(selProject);
		if( Object.keys(plist).length <= 1 ) $('#selproject').hide();
		console.log('labels', labels );
		console.log('annotators', annotators, aname);
		console.log('qcs', qcs );
		console.log('states', states );
		console.log('projects', projects, pname);

		function val(v){ return v.toFixed(1) }
		function ival(v){ return v.toFixed(0) }
		function pval(v){ return v.toFixed(1)+'%' }

		var nlabels = Object.keys(labels).length;
		var labMax = 15;
		if( nlabels > labMax ) nlabels = labMax;
		var gMax = 10;
		var gInc = 20;
		var gSize = 320;

		// Task State
		var stateColor = [ '#cccccc','#333377','#ff8833','#ff8800','#00cc00','#cc0000','#ff8833','#00cc00','#cc0000']
		var scolors = [];
		// var cfg = {
		// 	container:addChartDiv(),
		// 	title: 'Task States',
		// 	// max: 100,
		// 	format: ival,
		// 	formatTooltip: ival,
		// 	formatTick: ival,
		// 	paddingY: 30,
		// 	rotated: false,
		// 	// dataColor: function(c,d){ console.log( 'DATACOLOR', c, d ); return lcolors[d.x % lcolors.length]},
		// 	colorPattern: scolors,
		// 	// size:{height:500},
		// 	// basevalue:getVal,
		// 	// hideLegends: true,
		// 	hideY: true,
		// };
		// if( nlabels > gMax ) cfg.size = {height: gSize + (nlabels-gMax)*gInc};
		var d = {
			"values": [[]],
			"xLabels": ['Count'],
			"yLabels": [],
		};
		for( var l in states )
		{
			scolors.push( stateColor[l] );
			if( !window.window.stateLabels[l] ) console.log( 'STATEERROR', l )
			d.yLabels.push(window.window.stateLabels[l] || window.window.stateLabels[0]);
			d.values[0].push( states[l])
		}
		console.log( 'donut', d )

		// let xValuesArray = [];

		// if(Array.isArray(d.values[0])){
		// 	for (let j in d.values[0]) {
		// 		let row = [];
		// 		for (let i in d.values) {
		// 			row.push(d.values[i][j]);
		// 		}
		// 		xValuesArray.push(row);
		// 	}
	
		// 	for(let [index, xValue] of xValuesArray.entries()){
		// 		let trace = {};
		// 		trace = {
		// 			values: xValue,
		// 			domain: {column: index},
		// 			name: 'Count',
		// 			colors: scolors
		// 		}
		// 		xDataArray.push(trace)
		// 	}
		// }else{
		// 	let trace = {};
		// 	trace = {
		// 		values: d.values,
		// 		domain: {column: 0},
		// 		name: 'Count',
		// 		colors: scolors
		// 	}
		// 	console.log('wow', trace)
		// 	xDataArray.push(trace)
		// }

		let xDataArray = [];

		if(d.values.length > 1){
			for(let [index, xValue] of d.values.entries()){
				let trace = {};
				trace = {
					values: xValue,
					domain: {column: index},
					name: 'Count',
					colors: scolors
				}
				xDataArray.push(trace)
			}
		}else if(d.values.length == 1){
			let trace = {};
				trace = {
					values: d.values.flat(),
					domain: {column: 0},
					name: 'Count',
					colors: scolors
				}
				xDataArray.push(trace)
		}

		let data = {
            xData : xDataArray,
            labels: d.yLabels,
            container : addChartDiv()[0],
            grid : { rows: 1, columns: 1}
        }

		let config = {
			chartTitle: 'Task States',
            size: {
                height: '400',
                width: '650'
            },
		}

		plotly.drawDonutChart(data, config);

		// dash.drawGraphDonut(d,cfg);

		// labels Dashboard
		var llist = [];
		for( var l in labels ) { llist.push( {name:l, count: labels[l]})}
		var tit = 'Label Distribution';
		if( llist.length > labMax ) tit = 'Top Labels';
		llist.splice( labMax, 10000 );
		var lcolors = [];
		// var cfg = {
		// 	container:addChartDiv(),
		// 	title: tit,
		// 	// max: 100,
		// 	format: ival,
		// 	formatTooltip: ival,
		// 	formatTick: ival,
		// 	paddingY: 50,
		// 	rotated: true,
		// 	dataColor: function(c,d){ return lcolors[d.x % lcolors.length]},
		// 	// size:{height:500},
		// 	// basevalue:getVal,
		// 	hideLegends: true,
		// 	hideY: true,
		// };
		// if( nlabels > gMax ) cfg.size = {height: gSize + (nlabels-gMax)*gInc};
		var d = {
			"values": [],
			"xLabels": [],
			"yLabels": ["Label count"]
		};
		// for( var l in labels )
		for( var l of llist )
		{
			d.xLabels.push(l.name);
			d.values.push( [l.count])
		}
		lcolors = frm.paletteWheel(nlabels, 2)
		console.log( 'graph labels', d )

		let xValuesArray2 = [];
		let xDataArray2 = [];

		if(Array.isArray(d.values[0])){
			for (let j in d.values[0]) {
				let row = [];
				for (let i in d.values) {
					row.push(d.values[i][j]);
				}
				xValuesArray2.push(row);
			}
	
			for(let xValue of xValuesArray2){
				let trace = {};
				trace = {
                    values: xValue,
                    // name: 'bar1',
                    color: function (c, d) { return lcolors[d % lcolors.length] },
                    orientation: 'h',
                }
				xDataArray2.push(trace)
			}
		}else{
			let trace = {};
			trace = {
				values: d.values,
				// name: 'bar1',
				color: function (c, d) { return lcolors[d % lcolors.length] },
				orientation: 'h',
			}
			xDataArray2.push(trace)
		}

		let data2 = {
            xData : xDataArray2,
            showXlabels: false,
            yValues: d.xLabels,
            yLabel: 'Label count',
            container : addChartDiv()[0]
        }
    
        let config2 = {
            chartTitle: tit,
            size: {
                height: '650',
                width: '400'
            },
            // barmode: false,
            // dataColor : function (c, d) {  return lcolors[d % lcolors.length]; }
        }

		plotly.drawBarChart(data2, config2)

		// dash.drawGraphBar(d,cfg);

		var nprojects = Object.keys(projects).length;
		// Projects Dashboard
		var tcolors = [];
		// var cfg = {
		// 	container:addChartDiv(),
		// 	title: 'Tasks by Project',
		// 	// max: 100,
		// 	format: ival,
		// 	formatTooltip: ival,
		// 	formatTick: ival,
		// 	paddingY: 50,
		// 	rotated: true,
		// 	dataColor: function(c,d){ return tcolors[d.x % tcolors.length]},
		// 	// size:{height:500},
		// 	// basevalue:getVal,
		// 	hideLegends: true,
		// 	// hideY: true,
		// };
		tcolors = frm.paletteWheel(nprojects, 2)
		// if( nprojects > gMax ) cfg.size = {height: gSize + (nprojects-gMax)*gInc};
		var d = {
			"values": [],
			"xLabels": [],
			"yLabels": ["Tasks"]
		};
		for( var l in projects )
		{
			d.xLabels.push(pname[l]);
			d.values.push( [projects[l].tasks])
		}

		let xValuesArray3 = [];
		let xDataArray3 = [];

		if(Array.isArray(d.values[0])){
			for (let j in d.values[0]) {
				let row = [];
				for (let i in d.values) {
					row.push(d.values[i][j]);
				}
				xValuesArray3.push(row);
			}
	
			for(let xValue of xValuesArray3){
				let trace = {};
				trace = {
                    values: xValue,
                    // name: 'bar1',
                    color: function (c, d) { return lcolors[d % lcolors.length] },
                    orientation: 'h',
                }
				xDataArray3.push(trace)
			}
		}else{
			let trace = {};
			trace = {
				values: d.values,
				// name: 'bar1',
				color: function (c, d) { return lcolors[d % lcolors.length] },
				orientation: 'h',
			}
			xDataArray3.push(trace)
		}

		let data3 = {
            xData : xDataArray3,
            showXaxis: true,
            showXlabels: true,
            yValues: d.xLabels,
			yLabelAngle: -90,
            yLabel: 'Tasks',
            container : addChartDiv()[0]
        }
    
        let config3 = {
            chartTitle: 'Tasks by Project',
            size: {
                height: '650',
                width: '400'
            },
            // barmode: false,
            dataColor : function (c, d) {  return lcolors[d % lcolors.length]; }
        }

        plotly.drawBarChart(data3, config3);

		// dash.drawGraphBar(d,cfg);


		// var cfg = {
		// 	container:addChartDiv(),
		// 	title: 'Project Status',
		// 	// max: 100,
		// 	format: pval,
		// 	formatTooltip: pval,
		// 	formatTick: pval,
		// 	paddingY: 50,
		// 	rotated: true,
		// 	dataColor: function(c,d){ return tcolors[d.x % tcolors.length]},
		// 	// size:{height:500},
		// 	// basevalue:getVal,
		// 	hideLegends: true,
		// 	// hideY: true,
		// };
		// if( nprojects > gMax ) cfg.size = {height: gSize + (nprojects-gMax)*gInc};
		var d = {
			"values": [],
			"xLabels": [],
			"yLabels": ["Tasks"]
		};
		for( var l in projects )
		{
			d.xLabels.push(pname[l]);
			d.values.push( [projects[l].tasks ? 100*projects[l].completed/projects[l].tasks : 0])
		}

		let xValuesArray4 = [];
		let xDataArray4 = [];

		if(Array.isArray(d.values[0])){
			for (let j in d.values[0]) {
				let row = [];
				for (let i in d.values) {
					row.push(d.values[i][j]);
				}
				xValuesArray4.push(row);
			}
	
			for(let xValue of xValuesArray4){
				let trace = {};
				trace = {
                    values: xValue,
                    // name: 'bar1',
                    color: function (c, d) { return lcolors[d % lcolors.length] },
                    orientation: 'h',
					unit: '%'
                }
				xDataArray4.push(trace)
			}
		}else{
			let trace = {};
			trace = {
				values: d.values,
				// name: 'bar1',
				color: function (c, d) { return lcolors[d % lcolors.length] },
				orientation: 'h',
				unit: '%'
			}
			xDataArray4.push(trace)
		}

		let data4 = {
            xData : xDataArray4,
            showXaxis: true,
            showXlabels: true,
            yValues: d.xLabels,
            yLabel: 'Tasks',
			// yLabelAngle: -90,
            container : addChartDiv()[0]
        }
    
        let config4 = {
            chartTitle: 'Project Status',
            size: {
                height: '650',
                width: '400'
            },
            // barmode: false,
            dataColor : function (c, d) {  return lcolors[d % lcolors.length]; }
        }

        plotly.drawBarChart(data4, config4);

		// dash.drawGraphBar(d,cfg);

		function minutes( v )
		{
			return Math.floor( v/60 ) + ' min.';
		}

		function seconds( v )
		{
			return Math.floor( v ) + ' sec.';
		}

		var divAn = $('<table class="mt-4">')
		divAn.html('annot')
		db.append(divAn);

		var desc = {
			title: 'Annotators Throughput',
			columns: {
				name: 'Name',
				email: 'Email',
				tasks: 'Total Tasks',
				totalTime: 'Total Time',
				avgTime: 'Avg. Time',
			},
			filter: false,
			search: false,
			sort: true,
			initialSort: 'avgTime',
			initialSortDir: -1,
			pageSize: 10,
			noFilter: null,
			noSearch: null,
			noSort: null,
			centerCol: ['tasks','totalTime','avgTime'],
			format: tabler.formatString,
			formatCol:{
				totalTime: seconds,
				avgTime: seconds,
			}
		}
		var tabAnnotator = tabler.table(divAn, desc, 'annotatorThroughput' );
		for( var a in annotators )
		{
			tabAnnotator.addRow( {
				name: aname[a],
				email: a,
				tasks: annotators[a].tasks,
				totalTime: annotators[a].elapsedTime,
				avgTime: annotators[a].elapsedTime/annotators[a].tasks,
			})
		}
		tabAnnotator.draw();

		if( Object.keys(qcs).length )
		{
			var divQc = $('<table class="mt-4">')
			divQc.html('qc')
			db.append(divQc);

			var desc = {
				title: 'QCs Throughput',
				columns: {
					name: 'Name',
					email: 'Email',
					tasks: 'Total Tasks',
					totalTime: 'Total Time',
					avgTime: 'Avg. Time',
				},
				filter: false,
				search: false,
				sort: true,
				initialSort: 'avgTime',
				initialSortDir: -1,
				pageSize: 10,
				noFilter: null,
				noSearch: null,
				noSort: null,
				centerCol: ['tasks','totalTime','avgTime'],
				format: tabler.formatString,
				formatCol:{
					totalTime: seconds,
					avgTime: seconds,
				}
			}
			var tabQc = tabler.table(divQc, desc, 'qcThroughput' );
			for( var a in qcs )
			{
				tabQc.addRow( {
					name: aname[a],
					email: a,
					tasks: qcs[a].tasks,
					totalTime: qcs[a].elapsedTime,
					avgTime: qcs[a].elapsedTime/qcs[a].tasks,
				})
			}
			tabQc.draw();
		}

		$('text').css({fill:'#000000'})

	}

	function runDash(companies) {
		var match = { active: true, _sort: 'annotationCount', _sortDir: -1, _limit: 15 };
		if (companies) {
			if( companies.length == 1 ) match.company = companies[0];
			else match.company = { $in: companies };
		}
		window.post('find_projects', { match: match }, function (pres) {
			projectList = pres.data.records;
			dashboard();
			// console.log( 'pres', pres );
			// var pin = pres.data.records.map( p => p.id );
			// console.log( 'pin', pin )
			// var match = {project:{$in:pin}};
			// window.post( 'find_tasks', {match:match}, function(res){
			// 	tasks = res.data;
			// 	console.log( 'logs', tasks );
			// 	dashboard();
			// });
			setTimeout( function(){
				frm.convertSelects($('select'));
			}, 100 )
		});
	}

    useEffect( function(a){
		window.post( 'find_companies', {match:{active:true}}, function(cres){
			if( cres.data.records && cres.data.records.length )
			{
				companies = [];
				companyNames = {};
				cres.data.records.forEach( c => {
					companies.push( c._id );
					companyNames[c._id] = c.name;
				})
			}
			console.log( cres, companies );
			runDash(companies);
			frm.convertSelects($('select'));
		});

    });

    return (
        <div fluid="md p-0" className="maincontent">
        <div id="dashboard"></div>
        <span>&nbsp;</span>
        </div>
    )
}

export default Dashboard
